<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item"><router-link to="/kr/mypage/board/myThanks"> 고맙습니다 </router-link></li>
            <li class="tab-menu__item active"><router-link to="/kr/mypage/board/myTendinous"> 건의합니다 </router-link></li>
        </ul>
    </div>
    <p class="bullet03">접수 상태의 글은 수정 가능합니다. 단, 제목, 칭찬 직원, 부서/병동은 수정할 수 없으며 내용만 수정 가능합니다.</p>
    <p class="bullet03"><span>내용 외 다른 수정을 원하시면, 해당 글 삭제 후 &nbsp;<router-link to="/kr/tendinous/list"><b class="font-sub underline">이용안내 > 고객 서비스 > 건의합니다</b></router-link>&nbsp;에서 신규 글을 등록해주시기 바랍니다.</span></p>
    <div class="table-wrap">
        <div class="table column type02">
            <div class="table__inner">
                <table>
                    <colgroup>
                        <col style="width: 20%;">
                        <col style="width: 25%;">
                        <col style="width: 20%;">
                        <col style="width: 35%;">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>제목</th>
                            <td class="left" colspan="3">{{articleInfo.title}}</td>
                        </tr>
                        <tr>
                            <th>진행상황</th>
                            <td class="left">{{articleInfo.item18 == 'R' ? '접수' : '답변완료'}}</td>
                            <th>등록일자</th>
                            <td class="left">{{$commonUtils.timestampToDate(articleInfo.createdDt)}}</td>
                        </tr>
                        <tr>
                            <th>건의유형</th>
                            <td class="left" colspan="3">
                                {{articleInfo.item3}}
                            </td>
                        </tr>
                        <tr>
                            <th>내용</th>
                            <td class="left" colspan="3" v-html="articleInfo.content" v-if="pageMode == 'detail'"></td>
                            <!-- 수정필요(퍼블리싱) -->
                            <td class="left" colspan="3" v-else>
                                <textarea v-model="articleInfo.content"></textarea>
                            </td>
                        </tr>
                        <tr v-if="articleInfo.item18 != 'R' && articleInfo.reply">
                            <th>답변</th>
                            <td class="left" colspan="3">
                                <span class="answer-date">
                                    {{$commonUtils.timestampToDate(articleInfo.replyDt)}}
                                </span>
                                {{$commonUtils.removeTags(articleInfo.reply)}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="botton-wrap nowrap">
        <a href="javascript:;" class="sub-button c-sub" v-if="articleInfo.item18 == 'R' && pageMode == 'detail'" @click="showModify">수정</a>
        <a href="javascript:;" class="sub-button c-point-red" v-if="pageMode == 'detail'" @click="deleteArticle">삭제</a>
        <a href="javascript:;" class="sub-button c-sub" v-if="pageMode == 'modify'" @click="updateArticle">등록</a>
        <router-link :to="$route.path.replace('View', '')" class="sub-button c-gray">목록</router-link>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                articleInfo: {},
                attachList: '',
                boardNo: this.$route.query.boardNo | '',
                articleNo: this.$route.query.articleNo | '',
                pageMode: 'detail',
            };
        },
        methods: {
            getView() {
                this.axios
                .get(this.api.article.view + this.boardNo + '/' + this.articleNo, {
                        params: {
                            hospId: this.$store.getters.getHost,
                            articleNo: this.articleNo,
                            boardNo: this.boardNo
                        }
                    })
                    .then((res) => {
                        this.articleInfo = res.data
                        this.attachList = res.data.attachBag.attach;
                    });
            },
            showModify(){
                this.pageMode = 'modify';
            },
            deleteArticle() {
                if (confirm('삭제 후 복구하실 수 없습니다. 삭제하시겠습니까?')) {
                    const articleNo = this.articleInfo.articleNo
                    const articleNos = [articleNo]


                    this.axios.post(`${this.api.article.view}${this.boardNo}/del`, null, {
                        params: {
                            boardNo: this.boardNo,
                            articleNos: articleNos.join(',')
                        }
                    }).then(res => {
                        this.$router.push(this.$route.path.replace('View', ''))
                    })
                }
            },
            updateArticle(){
                if(!this.articleInfo.title){
                    alert('제목을 입력해 주세요.');
                    return
                }
                if(!this.articleInfo.content){
                    alert('내용을 입력해 주세요.');
                    return
                }
                if(confirm('글을 등록하시겠습니까?')){
                    this.axios({
                        method:"post",
                        url: this.api.mypage.articleUpdate, 
                        params: {
                            'boardNo' : this.boardNo
                            ,'articleNo' : this.articleNo
                            ,'title' : this.articleInfo.title
                            ,'content' : this.articleInfo.content
                            ,'item1' : this.articleInfo.item1
                            ,'item2' : this.articleInfo.item2
                            ,'item3' : this.articleInfo.item3
                        }
                    }).then(response => {
                        this.$router.push(this.$route.path.replace('View', ''))
                    });
                }
            },
        },
        mounted() {
            this.getView()
        }
    };
</script>

<style scoped></style>